module.exports = __webpack_public_path__ + "static/media/md-tennisball.43ef4a3d.svg";